import { Trans, useLingui } from '@lingui/react/macro'

import { H2 } from '../../_components/H2'
import { PrimaryButton } from '../../_components/PrimaryButton'

import { getLocalizedIndexImage, safeFromImages } from './localizedImages'

import LazyImage from '@/components/LazyImage'
import { useLocale } from '@/hooks/routes'
import { useScreen } from '@/hooks/screen'

export const SafeFrom: React.FC = () => {
  const isMd = useScreen('md')

  const { t } = useLingui()
  const locale = useLocale()
  const src = getLocalizedIndexImage(
    locale,
    isMd ? '/images/index/safe-from.png' : '/images/index/safe-from-phone.jpg',
    safeFromImages,
  )

  return (
    <div className='mx-auto max-w-[1160px] px-4 text-center'>
      <span
        style={{
          background:
            'linear-gradient(360deg, rgba(201, 175, 255, 0.2) 0%, rgba(121, 105, 153, 0.2) 100%)',
        }}
        className='text-f-other-9 mx-auto block w-fit rounded-full border border-[#C9AFFF33] px-5 py-1.5 text-xs md:text-sm'
      >
        <Trans>Royalty-Free</Trans>
      </span>
      <H2 className='pt-3 md:pt-6'>
        <Trans>Safe From Copyright Issues</Trans>
      </H2>
      <p className='text-f-other-10 pt-2 text-sm md:pt-3 md:text-xl'>
        <Trans>
          Worried about copyright infringement? With our AI song maker, you can
          rest easy. All the AI music generated under our paid plans is
          royalty-free, ensuring that you can use your unique songs without any
          legal concerns.
        </Trans>
      </p>
      <LazyImage
        width={1128}
        height={184}
        src={src}
        alt={t`Safe From Copyright Issues`}
        className='mt-6 md:mt-12'
      />
      <PrimaryButton
        href='/ai-music-generator'
        className='mx-auto mt-6 md:mt-16'
      >
        <Trans>Generate AI music now</Trans>
      </PrimaryButton>
    </div>
  )
}
